export namespace LyftDispatchRideStatusConstants {
  export const IN_QUEUE = 'inQueue';
  export const DISPATCH_FAILED = 'dispatchFailed';
  export const PENDING = 'pending';
  export const SCHEDULED = 'scheduled';
  export const ACCEPTED = 'accepted';
  export const ARRIVED = 'arrived';
  export const PICKED_UP = 'pickedUp';
  export const DROPPED_OFF = 'droppedOff';
  export const CANCELED = 'canceled';
  export const FAILED = 'failed';
  export const CANCEL_FAILED = 'cancelFailed';
  export const CANCEL_IN_QUEUE = 'cancelInQueue';
  export const UNKNOWN = 'unknown';
}
